"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); // (C) 2007-2018 GoodData Corporation

var routes_1 = require("./routes");

exports.transformDomainDataProduct = function (_a) {
  var domainDataProduct = _a.domainDataProduct;

  var _b = routes_1.parse(domainDataProduct.links.self, routes_1.CONTRACT_DATA_PRODUCT_DOMAIN_DATA_PRODUCT),
      contractId = _b.contractId,
      domainId = _b.domainId,
      dataProductId = _b.dataProductId;

  return __assign({
    contractId: contractId,
    domainId: domainId,
    dataProductId: dataProductId
  }, domainDataProduct);
};

var DomainDataProductModule =
/** @class */
function () {
  function DomainDataProductModule(xhr) {
    this.xhr = xhr;
  }

  DomainDataProductModule.prototype.getDomainDataProducts = function (contractId, dataProductId) {
    return this.xhr.get(routes_1.interpolate(routes_1.CONTRACT_DATA_PRODUCT_DOMAIN_DATA_PRODUCTS, {
      contractId: contractId,
      dataProductId: dataProductId
    })).then(function (result) {
      var _a = result.getData(),
          items = _a.domainDataProducts.items,
          status = _a.status;

      return {
        items: items.map(exports.transformDomainDataProduct),
        status: status
      };
    });
  };

  return DomainDataProductModule;
}();

exports.DomainDataProductModule = DomainDataProductModule;